import React from 'react';
import API from 'shared/constants/api';
import SpareImg from 'shared/components/SpareImg';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import Row from 'shared/components/AntdComponents/Grid/Row/Row';
import Col from 'shared/components/AntdComponents/Grid/Col/Col';
import { requestAutobooking } from 'shared/actions/advertForm';
import { bindActionCreators } from 'redux';
import queryString from 'query-string';

import { connect } from 'react-redux';

import Link from 'shared/components/Link/Link';
import withOrders from 'shared/hocs/withOrders';
import s from './AutobookingAdvert.css';

class AutobookingAdvert extends React.Component {
  static propTypes = {
    searchForm: PropTypes.shape(),
    partsForm: PropTypes.shape(),
    title: PropTypes.string,
    action: PropTypes.shape({ requestAutobooking: PropTypes.func }),
    advert: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    title: '',
    user: {},
    searchForm: {},
    partsForm: {},
    action: {},
    advert: {},
    globals: {},
    loading: false,
    minCustomReasonLength: 4,
    isUpdating: false,
    isRemoval: false,
  };

  state = {
    onModal: false,
    anotherReasonText: '',
  };

  handleChange(key, data) {
    const fun = {
      onModal: dat => {
        this.setState({ onModal: dat });
      },
      testAutobooking: () => {},
    };
    if (fun[key]) {
      fun[key](data);
    } else {
      console.error(key);
    }
  }

  render() {
    const {
      advert: { make = { title: '' }, model = { title: '' } },
      searchForm: {
        results: { topFirms = [] },
      },
      partsForm: {
        vocabulary: { url, queryobj: { location, makes } = {} },
      },
      title: titleMessage,
    } = this.props;
    if (!topFirms || !topFirms.length) return '';

    return (
      <div className={s.root}>
        <div className={s.title}>
          <FormattedMessage
            id={titleMessage}
            values={{ make: `${make.title ? make.title : ''} ${model.title ? model.title : ''}` }}
          />
        </div>
        {topFirms.map(({ title = '', logo = '', slug, id }) => (
          <div className={s.spare} key={id}>
            <Row style={{ width: '100%' }}>
              <Col span={8}>
                <Link to={API.KATALOG_KOMPANIY(slug)}>
                  <SpareImg photos={[{ image: logo }]} />
                </Link>
              </Col>
              <Col span={16}>
                <div>
                  {title && (
                    <Link className={s.spareTitle} to={API.KATALOG_KOMPANIY(slug)}>
                      {title}
                    </Link>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        ))}

        <Link className={s.allSpares} to={`${url}/?${queryString.stringify({ location, makes })}`}>
          <FormattedMessage
            id="Все СТО для {make}"
            values={{ make: `${make.title} ${model.title}` }}
          />
        </Link>
      </div>
    );
  }
}

export default connect(
  ({ searchForm, partsForm }) => ({
    searchForm,
    partsForm,
  }),
  dispatch => ({
    action: bindActionCreators({ requestAutobooking }, dispatch),
    dispatch,
  }),
)(withOrders(withStyles(s)(injectIntl(AutobookingAdvert))));



// WEBPACK FOOTER //
// ./src/shared/components/AutobookingForm/AutobookingAdvert.js